import { extractCourierAddressFromGoogle } from '@/utils/address'

export default {
  data() {
    return {
      localityCheck: {
        showCityConfirm: false,
        showUnavailable: false,
        showEmptyBasket: false,
        unavailableItems: [],
        headerCity: '',
        headerArea: '',
        profileCity: '',
        profileArea: '',
        triggerSource: '',
        resolved: false,
        addressKey: 0,
        savedFormatted: '',
        pendingCity: '',
        pendingArea: '',
        cityFieldLocked: false,
        addressFieldLocked: false,
      },
    }
  },
  methods: {
    async checkLocalityOnInit() {
      if (this.localityCheck.resolved) return

      // Лочим поле города только если из /init пришёл сохранённый профиль (и не только)
      if (this.addressInfo.PROFILE.CITY) {
        this.localityCheck.cityFieldLocked = true
      }

      try {
        await this.$store.dispatch('GET_LOCATION')
      } catch (error) {
        console.error('GET_LOCATION error:', error)
        this.localityCheck.cityFieldLocked = false
        return
      }

      const profileCity = this.addressInfo.PROFILE.CITY || ''
      const profileArea = this.addressInfo.PROFILE.AREA || ''
      const headerCity = this.$store.state.headerCity
      const headerArea = this.$store.state.headerArea

      if (!headerCity) {
        this.localityCheck.cityFieldLocked = false
        return
      }

      // Нет сохранённого профиля — проставляем город из хэдера
      if (!profileCity) {
        this.localityCheck.headerCity = headerCity
        this.localityCheck.headerArea = headerArea
        this.switchToHeaderCity()
        this.localityCheck.cityFieldLocked = false
        return
      }

      if (headerCity === profileCity) {
        this.localityCheck.cityFieldLocked = false
        return
      }

      this.localityCheck.headerCity = headerCity
      this.localityCheck.headerArea = headerArea
      this.localityCheck.profileCity = profileCity
      this.localityCheck.profileArea = profileArea
      this.localityCheck.triggerSource = 'init'

      let data
      try {
        data = await this.$store.dispatch('CHECK_LOCALITY', {
          city: profileCity,
          area: profileArea,
        })
      } catch (error) {
        console.error('checkLocalityOnInit CHECK_LOCALITY error:', error)
        this.localityCheck.cityFieldLocked = false
        return
      }

      // CHECK_LOCALITY ответил — поле разблокируется сразу,
      // даже если дальше будет показан попап подтверждения города.
      this.localityCheck.cityFieldLocked = false

      // BasketNotUpdated — товары совпадают, просто меняем город
      if (data.result?.status === 'BasketNotUpdated') {
        this.switchToHeaderCity()
        return
      }

      // BasketUpdated / BasketClear — показываем попап, ждём действия пользователя
      if (
        data.result?.status === 'BasketUpdated' ||
        data.result?.status === 'BasketClear'
      ) {
        if (data.result.status === 'BasketUpdated') {
          this.localityCheck.unavailableItems = data.result.change || []
        }
        this.localityCheck.showCityConfirm = true

        await new Promise((resolve) => {
          this.localityCheck._resolveInitCheck = resolve
        })
      }
    },

    // Смена города (поле "Город" или поле адреса) — вызываем CHECK_LOCALITY
    async checkLocalityFlow(city, area, triggerSource) {
      this.localityCheck.triggerSource = triggerSource
      this.localityCheck.headerCity = this.$store.state.headerCity
      this.localityCheck.headerArea = this.$store.state.headerArea
      this.localityCheck.profileCity = city
      this.localityCheck.profileArea = area

      this.localityCheck.cityFieldLocked = true

      let data
      try {
        data = await this.$store.dispatch('CHECK_LOCALITY', { city, area })
      } catch (error) {
        console.error('checkLocalityFlow CHECK_LOCALITY error:', error)
        this.localityCheck.cityFieldLocked = false
        return 'no_change'
      }

      if (data.result?.status === 'BasketNotUpdated') {
        this.localityCheck.cityFieldLocked = true
        try {
          await this.$store.dispatch('CHANGE_LOCALITY', { city, area })
        } catch (error) {
          console.error('CHANGE_LOCALITY error:', error)
        } finally {
          this.localityCheck.cityFieldLocked = false
        }
        return 'no_change'
      }

      this.localityCheck.cityFieldLocked = false

      if (data.result?.status === 'BasketUpdated') {
        this.localityCheck.unavailableItems = data.result.change || []
        this.localityCheck.showUnavailable = true
        return 'updated'
      }

      if (data.result?.status === 'BasketClear') {
        this._changeLocalityAndShowEmptyBasket()
        return 'empty'
      }

      return 'no_change'
    },

    // показ попапа, что баскет изменился, и синхронной замене локации
    _changeLocalityAndShowEmptyBasket() {
      this.localityCheck.showEmptyBasket = true
      this.localityCheck.cityFieldLocked = true

      const { profileCity, profileArea } = this.localityCheck
      try {
        this.$store.dispatch('CHANGE_LOCALITY', {
          city: profileCity,
          area: profileArea,
        })
      } catch (error) {
        console.error('CHANGE_LOCALITY error:', error)
      } finally {
        this.localityCheck.cityFieldLocked = false
      }
    },

    switchToHeaderCity() {
      this.localityCheck.resolved = true
      const { headerCity, headerArea } = this.localityCheck

      this.clearAddressFields(headerCity, headerArea)

      this.positionData.CITY_NAME = headerCity
      this.positionData.AREA_NAME = headerArea
      this.addressInfo.PROFILE.CITY = headerCity
      this.addressInfo.PROFILE.AREA = headerArea
    },

    clearAddressFields(newCity, newArea) {
      const keepKeys = [
        'CITY',
        'AREA',
        'COUNTRY',
        'COUNTRY_CODE',
        'COUNTRY_NAME',
      ]
      for (const key in this.addressInfo.PROFILE) {
        if (!keepKeys.includes(key)) {
          this.addressInfo.PROFILE[key] = ''
        }
      }
      this.addressInfo.formatted = ''

      const storeProfile =
        this.$store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS
      if (storeProfile) {
        for (const key in storeProfile) {
          if (!keepKeys.includes(key)) {
            storeProfile[key] = ''
          }
        }
        storeProfile.CITY = newCity
        storeProfile.AREA = newArea
      }

      this.localityCheck.addressKey++
    },

    // "Выбранный город" — переключаемся на город из хедера
    handleChooseHeaderCity() {
      this.localityCheck.showCityConfirm = false

      if (
        this.localityCheck.triggerSource === 'init' ||
        this.localityCheck.triggerSource === 'addressChange'
      ) {
        this.switchToHeaderCity()
        this._resolveLocalityGate()
        return
      }

      // cityField: CHECK_LOCALITY уже вызван, показываем попап по результату
      if (this.localityCheck.unavailableItems.length) {
        this.localityCheck.showUnavailable = true
      } else {
        this._changeLocalityAndShowEmptyBasket()
      }
    },

    // "Сохранённый адрес"
    handleChooseProfileCity() {
      this.localityCheck.showCityConfirm = false

      // cityField: просто закрываем, данные не изменены
      if (this.localityCheck.triggerSource === 'cityField') {
        return
      }

      // init / addressChange: показываем попап по результату CHECK_LOCALITY
      if (this.localityCheck.unavailableItems.length) {
        this.localityCheck.showUnavailable = true
      } else {
        this._changeLocalityAndShowEmptyBasket()
      }
    },

    // "Продолжить" — CHANGE_LOCALITY, остаёмся на чекауте
    async handleContinueWithUnavailable() {
      this.localityCheck.showUnavailable = false
      this.localityCheck.resolved = true
      const { city, area } = {
        city: this.localityCheck.profileCity,
        area: this.localityCheck.profileArea,
      }

      this.positionData.CITY_NAME = city
      this.positionData.AREA_NAME = area

      this.localityCheck.cityFieldLocked = true
      try {
        await this.$store.dispatch('CHANGE_LOCALITY', { city, area })
      } catch (error) {
        console.error('CHANGE_LOCALITY error:', error)
      } finally {
        this.localityCheck.cityFieldLocked = false
      }

      if (this.localityCheck.triggerSource === 'addressChange') {
        if (this.localityCheck.savedFormatted) {
          this.addressInfo.formatted = this.localityCheck.savedFormatted
        }
        const storeProfile =
          this.$store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS
        if (storeProfile) {
          storeProfile.CITY = city
          storeProfile.AREA = area
        }
        this.addressInfo.PROFILE.CITY = city
        this.addressInfo.PROFILE.AREA = area
        this.localityCheck.addressFieldLocked = true

        try {
          // Восстанавливаем улицу/дом/индекс из выбранной подсказки
          if (this.cityToChange && Object.keys(this.cityToChange).length) {
            const addressPatch = extractCourierAddressFromGoogle(
              this.cityToChange,
              this.getCountryCode
            )
            this.applyCourierAddressPatch(addressPatch)
            this.cityToChange = {}
          }

          await this.getDeliveryTypes()
        } finally {
          this.localityCheck.addressFieldLocked = false
        }
      } else if (this.localityCheck.triggerSource === 'profileChange') {
        // Пользователь подтвердил смену города при выборе профиля —
        // применяем данные профиля, которые были отложены
        this._applyPendingProfileData()
        await this.getDeliveryTypes()
      } else {
        this.clearAddressFields(city, area)
        this.addressInfo.PROFILE.CITY = city
        this.addressInfo.PROFILE.AREA = area
        this.positionData.CITY_NAME = city
        this.positionData.AREA_NAME = area
        await this.getFieldsConfig()
        // Резолвим промис — разблокируем отложенные delivery и order
        this._resolveLocalityGate()
        this.localityCheckPromise = null
        // Для не-init: вызываем delivery напрямую.
        // Order вызовется через цепочку delivery → payment → updateBasket
        if (this.localityCheck.triggerSource !== 'init') {
          await this.getDeliveryTypes()
        }
      }
    },

    _resolveLocalityGate() {
      if (this.localityCheck._resolveInitCheck) {
        this.localityCheck._resolveInitCheck()
        this.localityCheck._resolveInitCheck = null
      }
      if (this.localityCheck._resolveLocalityCheck) {
        this.localityCheck._resolveLocalityCheck()
        this.localityCheck._resolveLocalityCheck = null
      }
    },

    // Навигация с учётом WebView: в нативном приложении
    // отправляем сообщение через мост, иначе — обычный редирект
    _navigateTo(url) {
      if (!this.$store.state.isWebview) {
        window.location.href = url
        return
      }

      if (window.webkit?.messageHandlers?.goToCatalog) {
        window.webkit.messageHandlers.goToCatalog.postMessage('go-to-catalog')
        return
      }

      if (window.AndroidBridge) {
        window.AndroidBridge.postMessage('go-to-catalog')
        return
      }

      // Fallback — если что-то не то с мостом
      window.location.href = url
    },

    // "Проверить корзину" — CHANGE_LOCALITY, редирект на /basket
    async handleCheckBasket() {
      const { profileCity, profileArea } = this.localityCheck
      this.localityCheck.cityFieldLocked = true
      try {
        await this.$store.dispatch('CHANGE_LOCALITY', {
          city: profileCity,
          area: profileArea,
        })
      } catch (error) {
        console.error('CHANGE_LOCALITY error:', error)
      } finally {
        this.localityCheck.cityFieldLocked = false
      }
      window.location.href = '/basket/'
    },

    // "Перейти в каталог" — редирект на /shop
    async handleGoToCatalog() {
      this._navigateTo('/shop')
    },
  },
}
